import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const securityFeatures = [
    {
      id: 1,
      icon: "Shield",
      title: "SSL Encrypted",
      description: "256-bit encryption"
    },
    {
      id: 2,
      icon: "Lock",
      title: "SOC2 Compliant",
      description: "Enterprise security"
    },
    {
      id: 3,
      icon: "CheckCircle",
      title: "GDPR Ready",
      description: "Data protection"
    },
    {
      id: 4,
      icon: "Eye",
      title: "Privacy First",
      description: "Zero data sharing"
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
      {securityFeatures?.map((feature) => (
        <div
          key={feature?.id}
          className="flex flex-col items-center text-center p-4 glass rounded-xl border border-white/10 hover:border-white/20 transition-all duration-300"
        >
          <div className="w-10 h-10 bg-success/20 rounded-lg flex items-center justify-center mb-2">
            <Icon 
              name={feature?.icon} 
              size={20} 
              className="text-success" 
            />
          </div>
          <h3 className="text-sm font-semibold text-foreground mb-1">
            {feature?.title}
          </h3>
          <p className="text-xs text-text-secondary">
            {feature?.description}
          </p>
        </div>
      ))}
    </div>
  );
};

export default SecurityBadges;